document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".custom-collection__swiper", {
    slidesPerView: 1.3,
    spaceBetween: 14,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true, 
    },
    breakpoints: {
      640: {
        slidesPerView: 2.1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3.1,
      },
      1100: {
        slidesPerView: 4.04,
      },
      1460: {
        slidesPerView: 3.99,
      }
    },
  });
});
